var _rect, _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWorksSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#EAF2FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1403 19.427C15.6804 20.2345 15.2786 21.0708 14.7531 21.8209C14.3604 22.3825 13.8611 22.9006 13.3184 23.3196C11.9009 24.4141 10.0825 24.0164 9.17984 22.4678C8.52642 21.3479 7.88367 20.2214 7.236 19.0982C6.2817 17.443 5.31593 15.7943 4.37721 14.13C3.85088 13.197 3.87875 12.2353 4.43952 11.3286C4.98553 10.4473 5.81931 10.0128 6.85231 10.0488C7.88449 10.0849 8.65924 10.5883 9.17738 11.4885C10.444 13.6881 11.7148 15.8861 12.9847 18.0841C13.1618 18.3899 13.3397 18.6957 13.5463 19.0515C14.0505 18.2341 14.3538 17.4044 14.3899 16.487C14.394 16.3772 14.3211 16.2567 14.262 16.1534C13.8841 15.4885 13.4906 14.8334 13.1216 14.1636C12.3813 12.8223 12.838 11.1679 14.1407 10.4309C15.4631 9.68154 17.1044 10.1111 17.8775 11.4409C19.5164 14.2603 21.1569 17.0798 22.758 19.9205C23.6197 21.4503 22.8007 23.3516 21.1331 23.8385C19.9132 24.1952 18.6375 23.6967 17.9907 22.5973C17.4373 21.6561 16.8978 20.7068 16.351 19.7615C16.278 19.6352 16.196 19.5139 16.1419 19.4278L16.1403 19.427Z",
    fill: "#1A75FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2642 10.0468C23.7532 10.0468 22.5284 11.2716 22.5284 12.7826C22.5284 14.2935 23.7532 15.5184 25.2642 15.5184V17.3433C25.2642 17.3433 28 15.7209 28 12.7826C28 11.2716 26.7752 10.0468 25.2642 10.0468Z",
    fill: "#1A75FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_558_15037",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 10,
    width: 20,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1403 19.4277C15.6803 20.2353 15.2786 21.0715 14.7531 21.8216C14.3604 22.3832 13.8611 22.9014 13.3184 23.3203C11.9009 24.4148 10.0825 24.0172 9.17984 22.4685C8.52642 21.3486 7.88367 20.2221 7.236 19.099C6.2817 17.4437 5.31593 15.795 4.37721 14.1307C3.85088 13.1977 3.87875 12.2361 4.43952 11.3293C4.98553 10.448 5.81931 10.0135 6.85231 10.0496C7.88449 10.0856 8.65924 10.589 9.17738 11.4892C10.444 13.6888 11.7148 15.8868 12.9847 18.0848C13.1618 18.3906 13.3397 18.6964 13.5463 19.0522C14.0505 18.2348 14.3538 17.4052 14.3899 16.4878C14.394 16.3779 14.3211 16.2574 14.262 16.1541C13.8841 15.4892 13.4906 14.8341 13.1216 14.1643C12.3813 12.8231 12.838 11.1686 14.1407 10.4316C15.4631 9.68227 17.1044 10.1119 17.8775 11.4416C19.5164 14.2611 21.1569 17.0805 22.758 19.9213C23.6197 21.4511 22.8007 23.3523 21.1331 23.8393C19.9132 24.1959 18.6375 23.6974 17.9907 22.598C17.4373 21.6569 16.8978 20.7075 16.351 19.7622C16.278 19.636 16.196 19.5146 16.1419 19.4285L16.1403 19.4277Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_558_15037)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.401855,
    y: 12.3848,
    width: 10.1402,
    height: 18.9662,
    transform: "rotate(-30 0.401855 12.3848)",
    fill: "url(#paint0_linear_558_15037)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_558_15037",
    x1: 7.2115,
    y1: 25.2316,
    x2: 10.7044,
    y2: 24.8889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A75FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A48A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWorksSymbol);
export default __webpack_public_path__ + "static/media/logo_works_symbol.bd34e91186d4fc6eeaba5e3c5176a584.svg";
export { ForwardRef as ReactComponent };